// REACT
var React = require('react');
var ReactDOM = require('react-dom');

// LOCUSTUS
var empty = require('locutus/php/var/empty');
var isset = require('locutus/php/var/isset');
var count = require('locutus/php/array/count');
var round = require('locutus/php/math/round');
var array_slice = require('locutus/php/array/array_slice');

// OTHER LIBS
var Fuse = require('fuse.js');

const Posts = React.createClass({
    getInitialState: function() {
        var posts = window.posts;
        var title = window.pageTitle;

        var postTypes = [];
        if(!empty(window.postTypes)) {
            postTypes = window.postTypes;
        }

        var lastThreePosts = false;
        if(!empty(this.props.lastThreePosts) && this.props.lastThreePosts == "true") {
            lastThreePosts = true;
        }

        return {
            posts: posts, title: title, postTypes: postTypes, activePostType: 0, page: 1, search: "", lastThreePosts: lastThreePosts
        };
    },
    changePostType: function (e) {
        //console.log('changePostType ==> post type changed to: '+ e.currentTarget.value);
        this.setState({activePostType: e.currentTarget.value});
        //this.changePage(1);
        //this.changeSortOption('1');
        //console.log('Active Category Changed to: ', this.state.categories[e.currentTarget.value]);
    },
    changeSearch: function (e) {
        this.setState({search: e.currentTarget.value});
        //this.changePage(1);
        //console.log('Active Search Term Changed to: ', e.currentTarget.value);
    },
    //changePageClick: function (e) {
    //    var page = parseInt($(e.currentTarget).data('page'));
    //    this.changePage(page);
    //},
    //changePage: function (page) {
    //    this.setState({page: page});
    //    //console.log('Active Page Changed to: ', page);
    //},
    //changeSortOptionClick: function (e) {
    //    var option = $(e.currentTarget).data('option');
    //    this.changeSortOption(option);
    //},
    //changeSortOption: function (option) {
    //    this.setState({sortOption: option});
    //    this.changePage(1);
    //},
    //resetButton: function (e) {
    //    this.changePage(1);
    //    this.changeSortOption('1');
    //    this.setState({search: ''});
    //    this.setState({activePostType: 0});
    //},
    render() {
        var visiblePosts = [];
        var availablePosts = [];
        var page = parseInt(this.state.page) - 1;

        if(!empty(this.state.posts)) {
            availablePosts = this.state.posts;

            if(!empty(this.state.activePostType)) {
                //console.log('Inside render ==> post type changed to: '+this.state.activePostType);
                //console.log(this.state.postTypes.length);
                var options = {
                    shouldSort: true,
                    threshold: 0,
                    keys: [
                        {
                            name: 'post_type',
                            weight: 1
                        },
                        {
                            name: 'title',
                            weight: 0.9
                        }
                    ]
                };
                var fuseCategory = new Fuse(availablePosts, options);
                availablePosts = fuseCategory.search(this.state.postTypes[this.state.activePostType]);
            }

            if(!empty(this.state.search)) {
                var options = {
                    shouldSort: true,
                    threshold: 0.2,
                    keys: [
                        {
                            name: 'title',
                            weight: 1
                        }
                    ]
                };
                var fuseSearch = new Fuse(availablePosts, options);
                availablePosts = fuseSearch.search(this.state.search);
            }

            if(this.state.lastThreePosts) {
                visiblePosts = array_slice(availablePosts, 0, 3);
            } else {
                visiblePosts = [];
                for(var i = 0; i < availablePosts.length; i += 2) {
                    if(isset(availablePosts[i+1])) {
                        visiblePosts.push([availablePosts[i], availablePosts[i+1]]);
                    } else {
                        visiblePosts.push([availablePosts[i]]);
                    }
                }
            }
        }

        var _this = this;

        var header = (
            <div className='row post-title'>
                <div className="section-title pull-left">
                    <h2>{this.state.title}</h2>
                </div>
                <div className="search-input pull-right form-group">
                    <div>
                        <i className="fa fa-search" aria-hidden="true"></i>
                        <input type="text" className="form-control" placeholder="SUCHE" value={this.state.search} onChange={this.changeSearch} />
                    </div>
                </div>
                <div className="category-selector pull-right">
                    <div className="select-wrapper">
                        <select className="form-control" value={this.state.activePostType} onChange={this.changePostType}>
                            {this.state.postTypes.map(
                                function ( option, index ) {
                                    return (
                                        <option key={'option'+index} value={index}>
                                            {option}
                                        </option>
                                    );
                                }
                            )}
                        </select>
                    </div>
                </div>
            </div>
        );

        //console.log('showPosts.jsx: ' + this.props.lastThreePosts);

        if(this.state.lastThreePosts) {
            return (
                <div>
                    {header}
                    <div className='last-three-posts pure-g'>
                        {visiblePosts.map(
                            function ( post, index ) {
                                if(post['thumbnail_url'] == false) {
                                    // The post/tiding does not have a thumbnail
                                    return (
                                        <article key={'article-'+index} className="pure-u-1 pure-u-md-1-3 lastPost">
                                            <div className="pure-g">
                                                <div className="pure-g">
                                                    <div className="pure-u-1 pure-u-md-1-5 articleBackgroundImage">
                                                        <div className="date-label" style={{left: 0, right: 'auto'}}>
                                                            <span className="day">{post['day']}</span>
                                                            <span className="month">{post['month']}</span>
                                                        </div>
                                                    </div>
                                                    <div className="pure-u-1 pure-u-md-4-5 articleContent">
                                                        <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{post['post_type']}</p>
                                                        <a href={post['permalink']}><h3 style={{marginTop: 0}}>{post['title']}</h3></a>
                                                        {post['first_words']}
                                                        <a className="permalink" href={post['permalink']}>weiterlesen »</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                    );
                                } else {
                                    // The post/tiding has a thumbnail
                                    return (
                                        <article key={'article-'+index} className="pure-u-1 pure-u-md-1-3 lastPost">
                                            <div className="pure-g">
                                                <div className="pure-g">
                                                    <a className="pure-u-1 pure-u-md-1-2 articleBackgroundImage" href={post['permalink']} style={{backgroundImage: 'url('+post['thumbnail_url']+')'}}>
                                                        <div className="date-label">
                                                            <span className="day">{post['day']}</span>
                                                            <span className="month">{post['month']}</span>
                                                        </div>
                                                    </a>
                                                    <div className="pure-u-1 pure-u-md-1-2 articleContent">
                                                        <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{post['post_type']}</p>
                                                        <a href={post['permalink']}><h3 style={{marginTop: 0}}>{post['title']}</h3></a>
                                                        {post['first_words']}
                                                        <a className="permalink" href={post['permalink']}>weiterlesen »</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                    );
                                }
                            }
                        )}
                    </div>
                </div>
            )
        }

        else {
            //console.log(visiblePosts);
            return (
                <div>
                    {header}
                    {visiblePosts.map(
                        function ( posts, index ) {
                            if(posts.length == 2) {
                                posts[0]['pure-size'] = '1-2';
                                posts[1]['pure-size'] = '1-2';
                                if(posts[0]['thumbnail_url'] != false && posts[1]['thumbnail_url'] == false) {
                                    posts[0]['pure-size'] = '2-3';
                                    posts[1]['pure-size'] = '1-3';
                                    return (
                                        <div key={'article-'+posts[0]['id']} className="pure-g two-posts-row">
                                            <div className={"pure-u-1 pure-u-md-"+posts[0]['pure-size']}>
                                                <article className="lastPost">
                                                    <div className="pure-g">
                                                        <a className="pure-u-1 pure-u-md-1-2 articleBackgroundImage" href={posts[0]['permalink']} style={{backgroundImage: 'url('+posts[0]['thumbnail_url']+')'}}>
                                                            <div className="date-label">
                                                                <span className="day">{posts[0]['day']}</span>
                                                                <span className="month">{posts[0]['month']}</span>
                                                            </div>
                                                        </a>
                                                        <div className="pure-u-1 pure-u-md-1-2 articleContent">
                                                            <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[0]['post_type']}</p>
                                                            <a href={posts[0]['permalink']}><h3 style={{marginTop: 0}}>{posts[0]['title']}</h3></a>
                                                            {posts[0]['first_words']}
                                                            <a className="permalink" href={posts[0]['permalink']}>weiterlesen »</a>
                                                        </div>
                                                    </div>
                                                </article>
                                            </div>
                                            <div className={"pure-u-1 pure-u-md-"+posts[1]['pure-size']}>
                                                <article className="lastPost">
                                                    <div className="pure-g">
                                                        <div className="pure-u-1 pure-u-md-1 articleContent noBgImage">
                                                            <div className="date-label">
                                                                <span className="day">{posts[1]['day']}</span>
                                                                <span className="month">{posts[1]['month']}</span>
                                                            </div>
                                                            <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[1]['post_type']}</p>
                                                            <a href={posts[1]['permalink']}><h3 style={{marginTop: 0}}>{posts[1]['title']}</h3></a>
                                                            {posts[1]['first_words']}
                                                            <a className="permalink" href={posts[1]['permalink']}>weiterlesen »</a>
                                                        </div>
                                                    </div>
                                                </article>
                                            </div>
                                        </div>
                                    );
                                } else {
                                    if(posts[0]['thumbnail_url'] == false && posts[1]['thumbnail_url'] != false) {
                                        posts[0]['pure-size'] = '1-3';
                                        posts[1]['pure-size'] = '2-3';
                                        return (
                                            <div key={'article-'+posts[0]['id']} className="pure-g two-posts-row">
                                                <div className={"pure-u-1 pure-u-md-"+posts[0]['pure-size']}>
                                                    <article className="lastPost">
                                                        <div className="pure-g">
                                                            <div className="pure-u-1 pure-u-md-1 articleContent noBgImage">
                                                                <div className="date-label">
                                                                    <span className="day">{posts[0]['day']}</span>
                                                                    <span className="month">{posts[0]['month']}</span>
                                                                </div>
                                                                <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[0]['post_type']}</p>
                                                                <a href={posts[0]['permalink']}><h3 style={{marginTop: 0}}>{posts[0]['title']}</h3></a>
                                                                {posts[0]['first_words']}
                                                                <a className="permalink" href={posts[0]['permalink']}>weiterlesen »</a>
                                                            </div>
                                                        </div>
                                                    </article>
                                                </div>
                                                <div className={"pure-u-1 pure-u-md-"+posts[1]['pure-size']}>
                                                    <article className="lastPost">
                                                        <div className="pure-g">
                                                            <a href={posts[1]['permalink']} className="pure-u-1 pure-u-md-1-2 articleBackgroundImage" style={{backgroundImage: 'url('+posts[1]['thumbnail_url']+')'}}>
                                                                <div className="date-label">
                                                                    <span className="day">{posts[1]['day']}</span>
                                                                    <span className="month">{posts[1]['month']}</span>
                                                                </div>
                                                            </a>
                                                            <div className="pure-u-1 pure-u-md-1-2 articleContent">
                                                                <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[1]['post_type']}</p>
                                                                <a href={posts[1]['permalink']}><h3 style={{marginTop: 0}}>{posts[1]['title']}</h3></a>
                                                                {posts[1]['first_words']}
                                                                <a className="permalink" href={posts[1]['permalink']}>weiterlesen »</a>
                                                            </div>
                                                        </div>
                                                    </article>
                                                </div>
                                            </div>
                                        );
                                    }
                                    else {
                                        if(posts[0]['thumbnail_url'] == false && posts[1]['thumbnail_url'] == false) {
                                            return (
                                                <div key={'article-'+posts[0]['id']} className="pure-g two-posts-row">
                                                    <div className={"pure-u-1 pure-u-md-"+posts[0]['pure-size']}>
                                                        <article className="lastPost">
                                                            <div className="pure-g">
                                                                <div className="pure-u-1 pure-u-md-1 articleContent noBgImage">
                                                                    <div className="date-label">
                                                                        <span className="day">{posts[0]['day']}</span>
                                                                        <span className="month">{posts[0]['month']}</span>
                                                                    </div>
                                                                    <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[0]['post_type']}</p>
                                                                    <a href={posts[0]['permalink']}><h3 style={{marginTop: 0}}>{posts[0]['title']}</h3></a>
                                                                    {posts[0]['first_words']}
                                                                    <a className="permalink" href={posts[0]['permalink']}>weiterlesen »</a>
                                                                </div>
                                                            </div>
                                                        </article>
                                                    </div>
                                                    <div className={"pure-u-1 pure-u-md-"+posts[1]['pure-size']}>
                                                        <article className="lastPost">
                                                            <div className="pure-g">
                                                                <div className="pure-u-1 pure-u-md-1 articleContent noBgImage">
                                                                    <div className="date-label">
                                                                        <span className="day">{posts[1]['day']}</span>
                                                                        <span className="month">{posts[1]['month']}</span>
                                                                    </div>
                                                                    <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[1]['post_type']}</p>
                                                                    <a href={posts[1]['permalink']}><h3 style={{marginTop: 0}}>{posts[1]['title']}</h3></a>
                                                                    {posts[1]['first_words']}
                                                                    <a className="permalink" href={posts[1]['permalink']}>weiterlesen »</a>
                                                                </div>
                                                            </div>
                                                        </article>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        else { // posts[0]['thumbnail_url'] != false && posts[1]['thumbnail_url'] != false
                                            return (
                                                <div key={'article-'+posts[0]['id']} className="pure-g two-posts-row">
                                                    <div className={"pure-u-1 pure-u-md-"+posts[0]['pure-size']}>
                                                        <article className="lastPost">
                                                            <div className="pure-g">
                                                                <a className="pure-u-1 pure-u-md-1-2 articleBackgroundImage" href={posts[0]['permalink']} style={{backgroundImage: 'url('+posts[0]['thumbnail_url']+')'}}>
                                                                    <div className="date-label">
                                                                        <span className="day">{posts[0]['day']}</span>
                                                                        <span className="month">{posts[0]['month']}</span>
                                                                    </div>
                                                                </a>
                                                                <div className="pure-u-1 pure-u-md-1-2 articleContent">
                                                                    <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[0]['post_type']}</p>
                                                                    <a href={posts[0]['permalink']}><h3 style={{marginTop: 0}}>{posts[0]['title']}</h3></a>
                                                                    {posts[0]['first_words']}
                                                                    <a className="permalink" href={posts[0]['permalink']}>weiterlesen »</a>
                                                                </div>
                                                            </div>
                                                        </article>
                                                    </div>
                                                    <div className={"pure-u-1 pure-u-md-"+posts[1]['pure-size']}>
                                                        <article className="lastPost">
                                                            <div className="pure-g">
                                                                <a className="pure-u-1 pure-u-md-1-2 articleBackgroundImage" href={posts[1]['permalink']} style={{backgroundImage: 'url('+posts[1]['thumbnail_url']+')'}}>
                                                                    <div className="date-label">
                                                                        <span className="day">{posts[1]['day']}</span>
                                                                        <span className="month">{posts[1]['month']}</span>
                                                                    </div>
                                                                </a>
                                                                <div className="pure-u-1 pure-u-md-1-2 articleContent">
                                                                    <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[1]['post_type']}</p>
                                                                    <a href={posts[1]['permalink']}><h3 style={{marginTop: 0}}>{posts[1]['title']}</h3></a>
                                                                    {posts[1]['first_words']}
                                                                    <a className="permalink" href={posts[1]['permalink']}>weiterlesen »</a>
                                                                </div>
                                                            </div>
                                                        </article>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    }
                                }
                            }
                            else { // posts.length == 1
                                posts[0]['pure-size'] = '1-2';
                                if(posts[0]['thumbnail_url'] != false) { // The post has thumbnail
                                    return (
                                        <div key={'article-'+posts[0]['id']} className="pure-g two-posts-row">
                                            <div className={"pure-u-1 pure-u-md-"+posts[0]['pure-size']}>
                                                <article className="lastPost">
                                                    <div className="pure-g">
                                                        <a className="pure-u-1 pure-u-md-1-2 articleBackgroundImage" href={posts[0]['permalink']} style={{backgroundImage: 'url('+posts[0]['thumbnail_url']+')'}}>
                                                            <div className="date-label">
                                                                <span className="day">{posts[0]['day']}</span>
                                                                <span className="month">{posts[0]['month']}</span>
                                                            </div>
                                                        </a>
                                                        <div className="pure-u-1 pure-u-md-1-2 articleContent">
                                                            <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[0]['post_type']}</p>
                                                            <a href={posts[0]['permalink']}><h3 style={{marginTop: 0}}>{posts[0]['title']}</h3></a>
                                                            {posts[0]['first_words']}
                                                            <a className="permalink" href={posts[0]['permalink']}>weiterlesen »</a>
                                                        </div>
                                                    </div>
                                                </article>
                                            </div>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div key={'article-'+posts[0]['id']} className="pure-g two-posts-row">
                                            <div className={"pure-u-1 pure-u-md-"+posts[0]['pure-size']}>
                                                <article className="lastPost">
                                                    <div className="pure-g">
                                                        <div className="pure-u-1 pure-u-md-1 articleContent noBgImage">
                                                            <div className="date-label">
                                                                <span className="day">{posts[0]['day']}</span>
                                                                <span className="month">{posts[0]['month']}</span>
                                                            </div>
                                                            <p id="postType" style={{marginBottom: 0, color: 'rgba(255, 255, 255, 0.5)'}}>{posts[0]['post_type']}</p>
                                                            <a href={posts[0]['permalink']}><h3 style={{marginTop: 0}}>{posts[0]['title']}</h3></a>
                                                            {posts[0]['first_words']}
                                                            <a className="permalink" href={posts[0]['permalink']}>weiterlesen »</a>
                                                        </div>
                                                    </div>
                                                </article>
                                            </div>
                                        </div>
                                    );
                                }
                            }
                        }
                    )}
                </div>
            )
        }
    }
});

module.exports = Posts;

//$(window).ready(function() {
//    $('.openDetailsModal').click(function(e) {
//        var memberSelected = $(e.currentTarget).attr('data-member');
//        $('#detailsModal').show();
//    });
//
//    $('.closeDetailsModal').click(function() {
//        $('#detailsModal').hide();
//    })
//});